import { render, staticRenderFns } from "./StudentNoteFormView.vue?vue&type=template&id=62b65b23&scoped=true&"
import script from "./StudentNoteFormView.vue?vue&type=script&lang=js&"
export * from "./StudentNoteFormView.vue?vue&type=script&lang=js&"
import style0 from "./StudentNoteFormView.vue?vue&type=style&index=0&id=62b65b23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b65b23",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCol,VForm,VRow,VSubheader})
